export default "__VITE_ASSET__BBVloWU$__"